var React = require('react');

function Star (props) {
    return React.createElement("svg",props,[React.createElement("style",{"key":0}),React.createElement("path",{"className":"right","d":"M43.5 18.5c1-.9.4-2.6-.9-2.8l-12.4-1.8c-.5-.1-1-.4-1.2-.9L23.5 1.8c-.3-.6-.9-.9-1.5-.9v35.8c.3 0 .5.1.8.2l11.1 5.8c1.2.6 2.6-.4 2.4-1.7l-2.1-12.3c-.1-.5.1-1.1.5-1.4l8.8-8.8z","key":1}),React.createElement("path",{"className":"left","d":"M22 .8c-.6 0-1.2.3-1.5.9L15 13c-.2.5-.7.8-1.2.9L1.4 15.7c-1.3.2-1.9 1.8-.9 2.8l8.9 8.7c.4.4.6.9.5 1.4L7.8 40.9c-.2 1.3 1.2 2.4 2.4 1.7l11.1-5.8c.2-.1.5-.2.7-.2V.8z","key":2})]);
}

Star.defaultProps = {"version":"1.1","id":"レイヤー_1","x":"0","y":"0","viewBox":"0 0 44 44","xmlSpace":"preserve"};

module.exports = Star;

Star.default = Star;
